import Mediabox from '#components/common/mediabox/Mediabox';
import s from '#components/common/mediaBackground/mediaBackground.module.scss';

type Props = {
  src: string;
  srcSet?: string[];
  alt?: string;
};

const MediaBackground = ({ src, srcSet, alt }: Props) => (
  <div className={s.host}>
    <Mediabox src={src} srcSet={srcSet} alt={alt} aspectRatio="16_7" />
  </div>
);

export default MediaBackground;
